// Atom components have been replaced with MUI components
// Use MUI components directly: Button, TextField, Typography, etc.
export { default as Button } from './Button';
export { default as CompanyHeader } from './CompanyHeader';
export { default as DynamicFavicon } from './DynamicFavicon';
export { default as EmbeddedMap } from './EmbeddedMap';
export { default as LoadingSpinner } from './LoadingSpinner';
export { default as OptimizedImage } from './OptimizedImage';
export { default as OrangeLine } from './OrangeLine';
export { default as SEOHead } from './SEOHead';
export { default as Title } from './Title';

// Export types
export interface LoadingSpinnerProps {
  message?: string;
  size?: number;
}

export interface OrangeLineProps {
  width?: string | number;
  height?: string | number;
  margin?: string;
  mx?: string | number;
  my?: string | number;
  mb?: string | number;
  mt?: string | number;
}

export type { ButtonProps } from './Button';
export type { DynamicFaviconProps } from './DynamicFavicon';
export type { SEOHeadProps } from './SEOHead';
